<template>
    <div class="topbar" :class="`${$firstSectionPath}-topbar`">
        <div class="topbar-left">
            <div class="text-center">
                <router-link to="/crm" class="logo">
                    <i class="zmdi zmdi-toys icon-c-logo"></i><span>ATLAS</span>
                </router-link>
            </div>
        </div>

        <div class="navbar navbar-default" role="navigation">
            <div class="container-fluid">
                <div class="">
                    <div class="float-left">
                        <router-link to="/crm" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'crm'}">
                            <i class="fas fa-address-book"></i>
                            {{ $t("TopBar.crm") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/scanning" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'scanning'}">
                            <i class="fa fa-file-pdf"></i>
                            {{ $t("TopBar.scanning") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/printing" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'printing'}">
                            <i class="fa fa-print"></i>
                            {{ $t("TopBar.printing") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/stocks" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'stocks'}">
                            <i class="fab fa-stack-overflow"></i>
                            {{ $t("TopBar.stocks") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/distribution" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'distribution'}">
                            <i class="fa fa-shopping-bag"></i>
                            {{ $t("TopBar.distribution") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/shipping" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'shipping'}">
                            <i class="fa fa-truck"></i>
                            {{ $t("TopBar.shipping") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/billing" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'billing'}">
                            <i class="fa fa-euro-sign"></i>
                            {{ $t("TopBar.billing") }}
                        </router-link>
                    </div>
                    <div class="float-left">
                        <router-link to="/statistics" class="button-menu-mobile open-left waves-effect waves-light" :class="{selected: $firstSectionPath === 'statistics'}">
                            <i class="fas fa-chart-pie"/>
                            {{ $t("TopBar.statistics") }}
                        </router-link>
                    </div>

                    <ul class="nav navbar-right float-right">
                        <Notifications/>
                        <UserMenu/>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from "./Notifications";
import UserMenu from "./UserMenu";
export default {
    name: "TopBar",
    components: {UserMenu, Notifications},
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/scss/colors";

    .button-menu-mobile {
        font-size: 1.15em;
    }

    .topbar {
        transition: all ease 0.5s;
        &.crm-topbar {
            background-color: $crm-color;
            .selected {
                background-color: white;
                color: $crm-color;
            }
        }

        &.scanning-topbar {
            background-color: $scanning-color;
            .selected {
                background-color: white;
                color: $scanning-color;
            }
        }

        &.printing-topbar {
            background-color: $printing-color;
            .selected {
                background-color: white;
                color: $printing-color;
            }
        }

        &.stocks-topbar {
            background-color: $stocks-color;
            .selected {
                background-color: white;
                color: $stocks-color;
            }
        }

        &.distribution-topbar {
            background-color: $distribution-color;
            .selected {
                background-color: white;
                color: $distribution-color;
            }
        }

        &.shipping-topbar {
            background-color: $shipping-color;
            .selected {
                background-color: white;
                color: $shipping-color;
            }
        }

        &.billing-topbar {
            background-color: $billing-color;
            .selected {
                background-color: white;
                color: $billing-color;
            }
        }

        &.statistics-topbar {
            background-color: $statistics-color;
            .selected {
                background-color: white;
                color: $statistics-color;
            }
        }
    }
</style>